import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { ConfirmDialogInputNumberScope } from '../models/ConfirmDialogInputNumberScope';
import { IDataSourceInfo } from '../models/IDataSourceInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class ChangeExtractDsToLiveAction extends AbstractContentAction<IDataSourceInfo> {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate', 'DataSources'];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
            ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private Datasources: DataSources
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, dataSources: Set<IDataSourceInfo>) {

    const datasource = dataSources.first();
    const dataSourceIdArray = dataSources.map(ds => ds.id);
    dialogConfig.bodyText = Messages.confirmAreYouSure();
    dialogConfig.title = Messages.changeExtractDsToLive();
    dialogConfig.actionName = Messages.yes();
    let workbookId = datasource.workbook != null ? datasource.workbook.id : '';
    dialogConfig.action = () => this.Datasources.changeToLive(dataSourceIdArray, workbookId);
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'changeExtractDsToLiveSuccess',
      errorId: 'changeExtractDsToLiveError'
    };
  }

}

Module.instance().service('ChangeExtractDsToLiveAction', ChangeExtractDsToLiveAction);
